const {locale} = require('../../config.json');

function formatNumber(num, digits = 2, addSign = false) {
  return (
    (addSign && num > 0 ? '+' : '') +
    num.toLocaleString(locale, {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    })
  );
}

module.exports = {
  formatNumber
}